import { useEffect, useState } from 'react';
import { $CommonServiceFn } from '../network/Services';
import $Service_Url, { AoLoginUrl } from '../network/url';
import Loader from './Loader';

const Login = () => {

  const [authToken, setAuthToken] = useState('');
   const [useLoader, setuseLoader] = useState(false)


  useEffect(() => {
  const token = getQueryValue("token") || "";

  if (!token) {
    const newUrl = AoLoginUrl;
    window.location.replace(newUrl);
    return;
  }

  try {
    // Step 1: Clean and fix padding
    let cleanedToken = token.replace(/\s/g, ''); // remove spaces
    let paddedToken = cleanedToken.padEnd(cleanedToken.length + (4 - cleanedToken.length % 4) % 4, "=");

    // Step 2: Decode
    const decodedKey = atob(paddedToken);
    console.log("Decoded Key:", decodedKey);

    // Step 3: Parse values
    const loggenInId = getDecodedQueryValue(decodedKey, "loggenInId");
    const userId = getDecodedQueryValue(decodedKey, "userId");
    const roleId = getDecodedQueryValue(decodedKey, "roleId");
    const appState = getDecodedQueryValue(decodedKey, "appState");
    const paymentDashboard = getDecodedQueryValue(decodedKey, "paymentDashboard");

    if (loggenInId && userId && roleId && appState) {
      getLoggedInUser(userId, appState, loggenInId, roleId, paymentDashboard);
    } else {
      console.warn("Missing required fields in token.");
    }

  } catch (err) {
    console.error("Failed to decode token:", err.message);
    const fallbackUrl = AoLoginUrl;
    window.location.replace(fallbackUrl);
  }
}, []);

  const getQueryValue = (param) => new URLSearchParams(window.location.search).get(param);

  const getDecodedQueryValue = (query, param) => {
    const url = query.slice(query.indexOf('?') + 1).split('&');
    for (const pair of url) {
      const [key, value] = pair.split('=');
      if (key === param) return value?.split("#")[0];
    }
    return "";
  };

  const getLoggedInUser = (userId, appState, loggenInId, roleId, paymentDashboard) => {
    setuseLoader(true)
    const params = `?UserId=${userId}&AppState=${appState}&LoggenInId=${loggenInId}&RoleId=${roleId}`;
    $CommonServiceFn.InvokeCommonApi("GET", $Service_Url.getAthenticatePath + params, "", (response) => {
      const data = response?.data?.data;
      if (!data) return;

      sessionStorage.setItem("AuthToken", data.accessToken);
      sessionStorage.setItem("SubtenantId", data.subtenant_Id);
      sessionStorage.setItem("companyName", (data.subtenant_Id == 742 || data.subtenant_Id == 3) ? '' : 'life_point_law');
      const stateObj = {loggenInId,userId,roleId,appState,paymentDashboard};
      sessionStorage.setItem("stateObj", JSON.stringify(stateObj));
      sessionStorage.setItem("subtenantName", data.subtenantName);

      const loginDetail = {
        memberName: data.memberName,
        primaryEmailId: data.loginUserEmailId,
        userName: data.userName,
        userMob: data.primaryPhoneNumber,
        memberId: data.memberId,
        roleId: data.roleId,
        spouseName: data.spouseName
      };

      const loggedUserId = data.memberUserId;
      const roleUserId = data.roleId;

      sessionStorage.setItem("roleUserId", roleUserId);
      sessionStorage.setItem("userLoggedInDetail", JSON.stringify(loginDetail));
      sessionStorage.setItem("SessPrimaryUserId", loggedUserId);
      sessionStorage.setItem("userDetailOfPrimary", JSON.stringify(loginDetail));
      sessionStorage.setItem("loggedUserId", userId);

      if (appState && [3,4,6,11,13,14,15].includes(data.roleId) && paymentDashboard === "true") {
        window.location.replace('/')
         setuseLoader(false)
      }
    });
  };

  return (
  <>
       {useLoader && <div className='fixed inset-0 z-50 bg-white bg-opacity-30 backdrop-blur-sm  pointer-events-auto'>
            <Loader useLoader={useLoader} />
          </div>}
  </>
  );
};

export default Login;
